import React from 'react';
import { Table, Typography } from 'antd';
import { _T } from '../../../../../base-react/src/Localization';
import { hooks, models } from "@vote4dance/judging-sdk";
var Stream = hooks.streams.Stream;
var RoundResultSource = models.results.RoundResultSource;
var RoundJudgeSource = models.judges.RoundJudgeSource;
import { JudgingType, JudgeType } from '@vote4dance/judging-schema';
const { Text } = Typography;
export const RoundResultFooterSummary = (props) => {
    var _a;
    const { round, judgeColumnOffset = 2, totalVisibleColumnCount } = props;
    const [result] = Stream(RoundResultSource(round.round_id));
    const [judges] = Stream(RoundJudgeSource(round.competition_id, round.round_id));
    const visibleJudges = judges === null || judges === void 0 ? void 0 : judges.filter((judge) => judge.judge_type !== JudgeType.Trainee);
    const judgeCounts = React.useMemo(() => {
        const counts = {};
        result === null || result === void 0 ? void 0 : result.forEach(item => {
            if (item.judge_id) {
                counts[item.judge_id] = (counts[item.judge_id] || 0) + (item.result_rating && parseInt(item.result_rating) > 0 ? 1 : 0);
            }
        });
        return counts;
    }, [result]);
    const getJudgeValue = React.useCallback((judge) => { var _a; return (_a = judgeCounts[judge.judge_id]) !== null && _a !== void 0 ? _a : 0; }, [judgeCounts]);
    if (round.judging_type !== JudgingType.Select) {
        return null;
    }
    const summaryOffset = Math.max(1, judgeColumnOffset);
    const visibleJudgeCount = (_a = visibleJudges === null || visibleJudges === void 0 ? void 0 : visibleJudges.length) !== null && _a !== void 0 ? _a : 0;
    const trailingColumns = Math.max(0, (totalVisibleColumnCount !== null && totalVisibleColumnCount !== void 0 ? totalVisibleColumnCount : 0) - (summaryOffset + visibleJudgeCount));
    return (React.createElement(Table.Summary.Row, null,
        React.createElement(Table.Summary.Cell, { index: 0, colSpan: summaryOffset }, _T('common.total')), visibleJudges === null || visibleJudges === void 0 ? void 0 :
        visibleJudges.map((judge, index) => (React.createElement(Table.Summary.Cell, { index: summaryOffset + index, key: judge.judge_id },
            React.createElement(Text, null, getJudgeValue(judge))))),
        trailingColumns > 0 && (React.createElement(Table.Summary.Cell, { index: summaryOffset + visibleJudgeCount, colSpan: trailingColumns }))));
};
